/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const MenuUnfold = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M17 4H3v2h14zm-4 7H3v2h10zm4 7H3v2h14zm5.01-9.19L20.6 7.4 16 12l4.6 4.6 1.4-1.43L18.83 12z" />
  </Icon>
);
